import React from 'react';
import { motion } from 'framer-motion';
import { SarahTestimonial } from '../components/landing/SarahTestimonial';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { HeroSection } from '../components/landing/HeroSection';

export const SarahPage: React.FC = () => {
  return (
    <div className="space-y-24">
      <SarahTestimonial />
      <HeroSection />
      <div className="mt-24">
        <FeaturesSection />
      </div>
    </div>
  );
};